import { CircleArrowUp } from 'lucide-react'
import { lazy, Suspense, useState } from 'react'

import { Button } from '@/components/ui/button'
import { useBot } from '@/contexts/bot'
import useTranslator from '@/hooks/translation'

import type { BotEnvironment } from '../migration-create-dialog/utils/bot-environment'
import { MigrationPreselectDialog } from '../migration-preselect-dialog'

const importCreateDialog = () => import('../migration-create-dialog')

const MigrationCreateDialog = lazy(() =>
  importCreateDialog().then((module) => ({
    default: module.MigrationCreateDialog,
  })),
)

export function MigrationFlow() {
  const { getTranslation } = useTranslator()

  const [preselectOpen, setPreselectOpen] = useState(false)
  const [createOpen, setCreateOpen] = useState(false)
  const [selectedTargetEnv, setSelectedTargetEnv] =
    useState<BotEnvironment | null>(null)

  const { bot } = useBot()
  const botName = bot.name
  const sourceBotName = typeof botName === 'string' ? botName : ''

  const handleContinue = (env: BotEnvironment) => {
    setSelectedTargetEnv(env)
    setPreselectOpen(false)
    setCreateOpen(true)
  }

  const handleCreateOpenChange = (next: boolean) => {
    setCreateOpen(next)
    if (!next) setSelectedTargetEnv(null)
  }

  return (
    <>
      <Button
        type="button"
        variant="outline"
        disabled={!sourceBotName}
        onClick={() => {
          importCreateDialog()
          setPreselectOpen(true)
        }}
      >
        {getTranslation('botMigration.promote')}
        <CircleArrowUp />
      </Button>

      <MigrationPreselectDialog
        open={preselectOpen}
        onOpenChange={setPreselectOpen}
        sourceBotName={sourceBotName}
        onContinue={handleContinue}
      />

      {sourceBotName && selectedTargetEnv && (
        <Suspense fallback={null}>
          <MigrationCreateDialog
            open={createOpen}
            onOpenChange={handleCreateOpenChange}
            sourceBotName={sourceBotName}
            mode={{ type: 'create' }}
            initialTargetEnv={selectedTargetEnv}
          />
        </Suspense>
      )}
    </>
  )
}
